import { combineReducers } from 'redux';
import {
  FETCH_OTHER_PESTS,
  FETCH_OTHER_PESTS_SUCCESS,
} from '../actions/otherPestsRef';

const all = (state = [], action) => {
  switch (action.type) {
    case FETCH_OTHER_PESTS:
      return state;
    case FETCH_OTHER_PESTS_SUCCESS:
      return [...state, action.refs];
    default:
      return state;
  }
};

const isFetching = (state = false, action) => {
  switch (action.type) {
    case FETCH_OTHER_PESTS:
      return true;
    case FETCH_OTHER_PESTS_SUCCESS:
      return false;
    default:
      return state;
  }
};

const otherPestsRef = combineReducers({
  all,
  isFetching,
});

export default otherPestsRef;

export const getIsFetching = state => state.manips.otherPestsRef.isFetching;

export const getOtherPestsRef = state => state.manips.otherPestsRef.all[0];



// WEBPACK FOOTER //
// ./src/modules/saas/pco/interventions/manipulations/reducers/otherPestsRef.js